export const computedData = (data, prop = 'skillModelMaps', type) => { // 开启时，计算权重
  if (!Array.isArray(data)) return;
  let sum = 0;
  const average = Number((100 / data.length).toFixed(1));
  const newData = data.map((skill, idx) => {
    if (type === 'add' || skill.weight === '') {
      skill.weight = average;
    }
    // 计算最后一个数值
    if (idx < data.length - 1) {
      sum += skill.weight;
      // 当输入框输入的值之和大于99.9(因为最后一个权重最小为0.1)
      if (sum > 99.9) skill.weight = Number((skill.weight - (sum - 99.9)).toFixed(1));
    } else {
      const diff = Number((100 - sum).toFixed(1));
      skill.weight = diff <= 0.1 ? 0.1 : diff;
    }
    if (skill[prop]) skill[prop] = computedData(skill[prop], prop, type);
    return skill;
  });
  return newData;
};

export const averageData = (data, prop) => { // 未开启的话，计算平均数
  if (!Array.isArray(data)) return;
  const average = Number((100 / data.length).toFixed(1));
  const newData = data.map((skill) => {
    skill.weight = average;
    if (skill[prop]) skill[prop] = averageData(skill[prop]);
    return skill;
  });
  return newData;
};

export const formatDataRadar = (data, prop, enableWeightSwitch) => { // 处理预览数据
  const skillCatalogModels = data.map((item) => {
    // 未设置权重，需要计算平均值
    if (enableWeightSwitch !== 1) item[prop] = averageData(item[prop], 'skillModelMaps');
    item[prop] = item[prop].map((subItem) => {
      if (subItem.family === 1) {
        let combinedStdLevel = 0;
        let combinedExcellentLevel = 0;
        let combinedStdLevelStr = 0; // 标准分
        let excellentScore = 0; // 优秀分
        subItem.skillModelMaps.forEach((jqSkill) => {
          const weightPriority = Number(jqSkill.weight) / 100;
          const standardLevel = Number(jqSkill.standardLevel);
          const excellentLevel = Number(jqSkill.excellentLevel);
          const skillLevelMaps = jqSkill.skill.skillLevelMaps;
          const maxLevel = skillLevelMaps ? getMaxLevel(skillLevelMaps) : jqSkill.skill.maxLevel;
          // （权重x单能力标准分/能力总分x10)
          combinedStdLevel += (standardLevel / maxLevel) * 10 * weightPriority;
          combinedExcellentLevel += (excellentLevel / maxLevel) * 10 * weightPriority;
          jqSkill.standardLevelName = showName(jqSkill, 'standardLevel') || jqSkill.standardLevelName || jqSkill.standLevelName || jqSkill.standardLevelStr || '';
          jqSkill.combExcellentLevelName = showName(jqSkill, 'excellentLevel') || jqSkill.combExcellentLevelName || '';
          combinedStdLevelStr += (standardLevel * weightPriority);
          excellentScore += (excellentLevel * weightPriority);
        });
        return {
          ...subItem,
          combStandardLevel: combinedStdLevel,
          standardLevel: subItem.standardLevel,
          excellentEavl: combinedExcellentLevel,
          excellentScore: Number(excellentScore.toFixed(2)), // 优秀分
          combinedStdLevelStr: Number(combinedStdLevelStr.toFixed(2)), // 标准分
          standardLevelName: showName(subItem, 'standardLevel') || subItem.standardLevelName || subItem.standLevelName || subItem.standardLevelStr || '',
          combExcellentLevelName: showName(subItem, 'excellentLevel') || subItem.combExcellentLevelName || '',
          skillId: subItem && subItem.skillModelMaps && subItem.skillModelMaps.length && subItem.skillModelMaps[0].skillId || ''
        };
      } else {
        const skillLevelMaps = subItem.skill.skillLevelMaps;
        const maxLevel = skillLevelMaps ? getMaxLevel(skillLevelMaps) : subItem.skill.maxLevel;
        // 计算标准分 一级能力
        const combStandardLevel = (subItem.standardLevel / maxLevel) * 10;
        const combinedExcellentLevel = (subItem.excellentLevel / maxLevel) * 10;
        return {
          ...subItem,
          combStandardLevel,
          standardLevel: subItem.standardLevel,
          maxLevel: maxLevel,
          excellentEavl: combinedExcellentLevel,
          standardLevelName: showName(subItem, 'standardLevel') || subItem.standardLevelName || subItem.standLevelName || subItem.standardLevelStr || '',
          combExcellentLevelName: showName(subItem, 'excellentLevel') || subItem.combExcellentLevelName || ''
        };
      }
    });
    return {
      ...item
    };
  });
  return skillCatalogModels;
};

export const getMaxLevel = (list) => {
  return Math.max.apply(
    Math,
    list.map((item) => {
      return item.level;
    })
  );
};

export const showName = (row, prop) => {
  if (row && row.skill && row.skillLevelMaps) {
    const skill = row.skill.skillLevelMaps.find(
      (item) => item.level === Number(row[prop])
    );
    return skill ? skill.name : '';
  } else {
    return '';
  }
};

